import React from "react";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import pull from "lodash/pull";
import multiSelectStyles from "../multiSelectStyles";
import { UserFilterCategory } from "../UserFilterCategory/UserFilterCategory";
import { FilterOptionsGroup } from "../FilterOptionsGroup/FilterOptionsGroup";
import keyBy from "lodash/keyBy";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";

export interface PayGroupFilterProps {
  filter: string[];
  onFilterChange: (newFilters: string[]) => void;
}

const MAX_COMPANIES_LENGTH_FOR_CHECKBOXES = 10;

export const PayGroupFilter = (props: PayGroupFilterProps) => {
  const { filter, onFilterChange } = props;
  const { companies } = usePartnerConfig();

  const companiesMap = keyBy(companies, "id");

  if (companies.length <= 1) {
    return null;
  }

  return (
    <UserFilterCategory title="Pay Group">
      {
        companies.length <= MAX_COMPANIES_LENGTH_FOR_CHECKBOXES
          ? (
            <FilterOptionsGroup
              options={companies.map(company => ({
                key: company.id,
                label: company.payGroup,
                selected: filter.includes(company.id),
              }))}
              onChange={(key: string, selected: boolean) => {
                const newState = [...filter];
                if (selected) {
                  newState.push(key);
                } else {
                  pull(newState, key);
                }
                onFilterChange(newState);
              }}
            />
          )
          : (
            <DPReactSelect
              value={filter.map(payGroupId => ({
                label: companiesMap[payGroupId].payGroup,
                value: payGroupId,
              }))}
              options={companies.map(company => ({
                label: company.payGroup,
                value: company.id,
              }))}
              onChange={(newOptions: { label: string; value: string }[]) => {
                onFilterChange(newOptions?.map(option => option.value) || []);
              }}
              isMulti
              closeMenuOnSelect={false}
              styles={multiSelectStyles}
            />
          )
      }
    </UserFilterCategory>
  );
};
